import { createFileRoute } from "@tanstack/react-router";

import LiveAlerts from "/src/routes/live-alerts/-live-alerts";

export const Route = createFileRoute("/_main/live-alerts")({
  component: LiveAlerts,
});
